<div class="cotum_loader" *ngIf="!cIsEditDisabled && loader && !approvedData.isApproved">
  <div class="step1_loader">
    <div>
      <div style="text-align: center;"><img src="../../../assets/img/ai_cratation.gif" alt="" style="height: 84px;">
      </div>

      <div
        style="text-align: center; margin-top: 13px;font-family: 'Inter', sans-serif; font-weight: 600; font-size: 18px;  ">
        Generating With AI</div>

      <div style="    display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 34px;">
        <div class="loader_3_line_main_div">
          <div class="loader_3_line_circle">&nbsp;</div>
          <div class="loader_3_line_txt">Generating restaurant background image
          </div>
        </div>

        <div class="loader_3_line_main_div">
          <div class="loader_3_line_circle">&nbsp;</div>
          <div class="loader_3_line_txt">Analysing vast amounts of your restaurant related data</div>
        </div>

        <div class="loader_3_line_main_div">
          <div class="loader_3_line_circle">&nbsp;</div>
          <div class="loader_3_line_txt">Generating editable restaurant data for you.</div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="preloading_main_div" *ngIf="preloadingFlag">
  <span class="loader"></span>
</div>


<div class="cotum_loader" *ngIf="finalLoader">
  <div class="step1_loader">
    <div>
      <div style="text-align: center; height: 80px;">&nbsp;</div>

      <div
        style="text-align: center; margin-top: 13px;font-family: 'Inter', sans-serif; font-weight: 600; font-size: 18px;">
          Congratulations!</div>

      <div style="text-align: center;
      margin-top: 15px;
      font-family: 'IBM Plex Sans', sans-serif;
      font-size: 16px;
      font-weight: 500;">
        Your free listing has been approved! <br />
        Your restaurant will now be automatically showcased <br /> to the most relevant potential customers!.
      </div>


      <div style="
          margin-top: 6rem;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 14px;
    text-align: center;
    font-weight: 500;">Want to download sample menu QR code? <span style="color: #4790a4;
    cursor: pointer;
    font-weight: 600;" (click)="downLoadQrWeb()">DOWNLOAD</span> </div>
    </div>
  </div>
</div>


<div class="cl_con_3">
  <div>
    <div class="claim_header_div">
      <img src="../../../assets/img/foodbud_icon.svg" alt="logo-img" style="width: 65px;" />
    </div>
  </div>


  <div *ngIf="!failToFetchDataFlag">

    <div class="banner-rail" *ngIf="!approvedData.isApproved">
      <div class="banner">
        <div class="banner-sub">
          <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor"
              d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.1 13.4-3.6-3.6 1.4-1.4 2.2 2.2 4.9-4.9 1.4 1.4-6.3 6.3z" />
          </svg>

          <p class="msg">
            <strong>🎉 Congratulations!</strong> 
            Your listing has been successfully verified and connected to <strong>{{cRestoEmail}}</strong>.
            To make any updates, simply click Edit and then Update.
            Your food business will now be <strong>automatically recommended on the Foodbud app </strong> as a verified listing - helping more customers discover you!
          </p>
          <span class="spacer"></span>


        </div>
        <button class="close" type="button" onclick="this.parentElement.style.display='none'"
          aria-label="Dismiss notification">
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor"
              d="m13.41 12 5.3-5.29-1.42-1.42L12 10.59 6.71 5.29 5.29 6.71 10.59 12l-5.3 5.29 1.42 1.42L12 13.41l5.29 5.3 1.42-1.42z" />
          </svg>
        </button>
      </div>
    </div>


    <div class="container_img_slider_div">
      <img [src]="imageSliderSrc[imageIndex]" alt="slider"
        style="width: 100%;height: 100%;object-fit: cover;object-position: center; transition: opacity 3s ease-in-out; border-radius: 10px;">

      <div class="upload-overlay">
        <input type="file" accept="image/png,image/jpeg" (change)="onBannerChange($event)" #bannerFileInput hidden />
        <button class="upload-btn" (click)="bannerFileInput.click()">
          <div style="display: flex; align-items: center; gap: 5px;">
            <img src="../../../assets/img/blue-symbols_upload-rounded.svg" alt="upload-icon"
              style="width: 20px; height: 20px;" />
            <span>Upload</span>
          </div>
        </button>
      </div>
    </div>
  </div>

  <div>
    <hr style="border-color: #96B0B8;" />
  </div>



  <!-- Restaurant details -->
  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Restaurant details</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.restoDtls}" (click)="turnOnEdit('restoDtls')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.restoDtls"
          (click)="saveEdit('restoDtls')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.restoDtls"
          (click)="cancelEdit('restoDtls')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>

    <div class="cl_card_body cl_grid">
      <div>
        <div>
          <span class="cl_label_heading">Restaurant Name:</span>
          <br />
          <input type="text" style="font-weight: 700; text-transform: capitalize;" class="inp_costum"
            [(ngModel)]="cRestoName" [disabled]="true" />
        </div>
        <!-- -------------- -->
        <div class="mt_18">
          <span class="cl_label_heading">About:</span>
          <br />
          <textarea class="inp_costum" matInput cdkTextareaAutosize style="resize: none;" [(ngModel)]="cRestoAbout"
            [disabled]="cIsEditDisabledFlag.restoDtls"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.restoDtls}"
            style="text-align: justify;"></textarea>
        </div>
        <!-- -------------- -->
        <div class="mt_18">
          <span class="cl_label_heading">Address:</span>
          <br />
          <textarea class="inp_costum" matInput cdkTextareaAutosize style="resize: none;" [(ngModel)]="cRestoAddress"
            [disabled]="cIsEditDisabledFlag.restoDtls"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.restoDtls}"></textarea>
        </div>
        <!-- -------------- -->
        <div class="mt_18">
          <span class="cl_label_heading">Phone:</span>
          <br />
          <input type="text" class="inp_costum" [(ngModel)]="cRestoPhone" [disabled]="cIsEditDisabledFlag.restoDtls"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.restoDtls}" />
        </div>
        <!-- -------------- -->
        <div class="mt_18">
          <span class="cl_label_heading">Website:</span>
          <br />
          <input type="url" class="inp_costum" [(ngModel)]="cRestoWebsite" [disabled]="cIsEditDisabledFlag.restoDtls"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.restoDtls}" />
        </div>
        <!-- -------------- -->
        <div class="mt_18">
          <span class="cl_label_heading">Email:</span>
          <br />
          <input type="email" class="inp_costum" [(ngModel)]="cRestoEmail" [disabled]="true" />
        </div>
        <!-- -------------- -->
      </div>
      <div>

        <div class="mt_18" *ngIf="cRestoAvgRating">
          <span class="cl_label_heading">Avg. Rating:</span>
          <br />
          <input type="email" class="inp_costum" [(ngModel)]="cRestoAvgRating" [disabled]="true" />
        </div>

        <div class="mt_18">
          <span class="cl_label_heading">Restaurant Logo (Less than 500kb):</span>
          <br />
          <div style="display: flex;align-items: center;gap: 33px;">
            <div class="cl_resto_logo">
              <img [src]="logoSrc" alt="logo-img" style="max-width: 100px; max-height: 100px;" />
            </div>

            <input type="file" accept="image/png,image/jpeg" (change)="onLogoChange($event)" #fileInput_image hidden />
            <button class="cl_logo_btn_upload" *ngIf="!cIsEditDisabledFlag.restoDtls" (click)="fileInput_image.click()">
              <img src="../../../assets/img/upload.svg" alt="">
              <span>Upload</span>
            </button>
          </div>
        </div>


      </div>
    </div>
  </div>



  <!-- Opening and closing hours -->

  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Opening and closing hours</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.opCloHr}" (click)="turnOnEdit('opCloHr')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.opCloHr"
          (click)="saveEdit('opCloHr')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.opCloHr"
          (click)="cancelEdit('opCloHr')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>

    <div class="cl_card_body">
      <div class="bigScreen">
        <div style="margin-left: 15px; display: grid; grid-template-columns: 1fr 1fr 1fr;">
          <div class="time-text">Select days</div>
          <div class="time-text">Open timings</div>
          <div class="time-text">Close timings</div>

          <ng-container *ngFor="let day of days; let i = index">
            <div style="display: flex; margin-bottom: 15px;">
              <div class="cuisine-name m-l-0">
                <input type="checkbox" class="inp_checkox_time" [(ngModel)]="timeData[day.short].isChecked"
                  [disabled]="cIsEditDisabledFlag.opCloHr" />
                {{ day.name }}
              </div>
            </div>
            <ng-container *ngIf="!cIsEditDisabledFlag.opCloHr; else showAsAText">
              <!-- Open Time -->
              <div>
                <input class="time-input" type="text" maxlength="2" placeholder="HH"
                  [(ngModel)]="timeData[day.short].openHH"
                  (input)="enforceTimeLimits(timeData[day.short].openHH, 12, day.short, 'openHH')"
                  [disabled]="cIsEditDisabledFlag.opCloHr" />
                <span>:</span>
                <input class="time-input" type="text" maxlength="2" placeholder="MM"
                  [(ngModel)]="timeData[day.short].openMM"
                  (input)="enforceTimeLimits(timeData[day.short].openMM, 59, day.short, 'openMM')"
                  [disabled]="cIsEditDisabledFlag.opCloHr" />
                <select class="time-selectOption" [(ngModel)]="timeData[day.short].openMead"
                  [disabled]="cIsEditDisabledFlag.opCloHr">
                  <option value="am">AM</option>
                  <option value="pm">PM</option>
                </select>
              </div>

              <!-- Close Time -->
              <div>
                <input class="time-input" type="text" maxlength="2" placeholder="HH"
                  [(ngModel)]="timeData[day.short].closeHH"
                  (input)="enforceTimeLimits(timeData[day.short].closeHH, 12, day.short, 'closeHH')"
                  [disabled]="cIsEditDisabledFlag.opCloHr" />
                <span>:</span>
                <input class="time-input" type="text" maxlength="2" placeholder="MM"
                  [(ngModel)]="timeData[day.short].closeMM"
                  (input)="enforceTimeLimits(timeData[day.short].closeMM, 59, day.short, 'closeMM')"
                  [disabled]="cIsEditDisabledFlag.opCloHr" />
                <select class="time-selectOption" [(ngModel)]="timeData[day.short].closeMead"
                  [disabled]="cIsEditDisabledFlag.opCloHr">
                  <option value="am">AM</option>
                  <option value="pm">PM</option>
                </select>

                <!-- <span class="clear-timeBtn" *ngIf="shouldShowClear(day.short)" (click)="clearTime(day.short)">Clear</span>

              <span *ngIf="i > 0 && isPreviousDayFilled(i)">
                |
                <button mat-raised-button matTooltip="Copy time from previous day"
                  (click)="copyFromPreviousDay(i)">Copy</button>
              </span> -->
              </div>
            </ng-container>
            <ng-template #showAsAText>
              <!-- Open Time -->
              <div style="display: flex; gap: 2px;">
                <span>{{timeData[day.short].openHH == '' ? 'HH' : timeData[day.short].openHH}}</span>
                <span>:</span>
                <span>{{timeData[day.short].openMM == '' ? 'MM' : timeData[day.short].openMM}}</span>
                <span style="text-transform: uppercase;">{{timeData[day.short].openMead}}</span>
              </div>

              <!-- Close Time -->
              <div style="display: flex; gap: 2px;">
                <span>{{timeData[day.short].closeHH == '' ? 'HH' : timeData[day.short].closeHH}}</span>
                <span>:</span>
                <span>{{timeData[day.short].closeMM == '' ? 'MM' : timeData[day.short].closeMM}}</span>
                <span style="text-transform: uppercase;">&nbsp;{{timeData[day.short].closeMead}}</span>
              </div>
            </ng-template>

          </ng-container>
        </div>
      </div>
    </div>
  </div>


  <!-- Cuisine type -->
  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Cuisine type</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.cuisine}" (click)="turnOnEdit('cuisine')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.cuisine"
          (click)="saveEdit('cuisine')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.cuisine"
          (click)="cancelEdit('cuisine')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>
    <div class="cuisine-div" id="cuisine">
      <div *ngFor="let item of allCuisine" style="display: flex; margin-bottom :15px;">
        <div class="cuisine-name m-l-0">
          <input type="checkbox" name="" id="" class="inp_checkox_time" [checked]="preSelectFunc('cuisines',item.id)"
            (change)="cuisineCheckedUncheckedFunc($event.target, item.id)" [disabled]="cIsEditDisabledFlag.cuisine">
          {{item.name}}
        </div>
      </div>
    </div>
  </div>

  <!-- Dietary preference -->
  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Dietary preference</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.dietPref}" (click)="turnOnEdit('dietPref')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.dietPref"
          (click)="saveEdit('dietPref')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.dietPref"
          (click)="cancelEdit('dietPref')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>
    <div class="cuisine-div" id="dietPref">
      <div *ngFor="let item of allDieatary" style="display: flex; margin-bottom :15px;">
        <div class="cuisine-name m-l-0">
          <input type="checkbox" name="" id="" class="inp_checkox_time" [checked]="preSelectFunc('dietPref',item.id)"
            (change)="dpCheckedUncheckedFunc($event.target, item.id)" [disabled]="cIsEditDisabledFlag.dietPref">
          {{item.name}}
        </div>
      </div>
    </div>
  </div>

  <!-- Food Category -->
  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Food Category</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.category}" (click)="turnOnEdit('category')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.category"
          (click)="saveEdit('category')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.category"
          (click)="cancelEdit('category')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>
    <div class="cuisine-div" id="dietPref">
      <div *ngFor="let item of allCaategory" style="display: flex; margin-bottom :15px;">
        <div class="cuisine-name m-l-0">
          <input type="checkbox" name="" id="" class="inp_checkox_time"
            [checked]="preSelectFunc('categories',item.category_id)"
            (change)="catCheckedUncheckedFunc($event.target, item.category_id)"
            [disabled]="cIsEditDisabledFlag.category">
          {{item.category_name}}
        </div>
      </div>
    </div>
  </div>

  <!-- Special offers/events -->
  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Special Offers/Events</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.spacialOffer}" (click)="turnOnEdit('spacialOffer')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.spacialOffer"
          (click)="saveEdit('spacialOffer')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.spacialOffer"
          (click)="cancelEdit('spacialOffer')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>
    <div class="social_link_main_div">
      <div class="offer-main-div" *ngFor="let day of spacialOffer | keyvalue : weekdaySort">
        <div class="offer-sub-div">
          <input type="checkbox" name="" id="" class="inp_checkox_time"
            (change)="spacialOfferHandle(day.key ,$event.target)" [(checked)]="day.value.flag"
            [disabled]="cIsEditDisabledFlag.spacialOffer">
          <div class="cuisine-name" style="margin-top: 0;">
            {{day.key}}
          </div>
        </div>
        <div class="offer-sub-div" *ngIf="day.value.flag">
          <input type="text" name="" id="" class="inp_costum" style="margin: auto 0;" [(ngModel)]="day.value.value"
            placeholder="Please enter the special offers/event" [disabled]="cIsEditDisabledFlag.spacialOffer"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.spacialOffer}">
        </div>
      </div>
    </div>
  </div>


  <!-- Socail Links -->
  <div class="cl_card_main_div">
    <div class="cl_card_heading">
      <span>Socail Links</span>
      <div class="cl_quick_btn_main_div" *ngIf="!failToFetchDataFlag">
        <div class="cl_quick_btn_div" style="color: #FFFFFF;"
          [ngClass]="{cl_quick_btn_disabled : !cIsEditDisabledFlag.socialLink}" (click)="turnOnEdit('socialLink')">
          <span>EDIT</span>
          <img src="../../../assets/img/basil_edit-outline.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.socialLink"
          (click)="saveEdit('socialLink')">
          <span>SAVE</span>
          <img src="../../../assets/img/mingcute_save-line.svg" alt="">
        </div>
        <div class="cl_quick_btn_div" style="color: #FFFFFF;" *ngIf="!cIsEditDisabledFlag.socialLink"
          (click)="cancelEdit('socialLink')">
          <span>CANCEL</span>
          <img src="../../../assets/img/material-symbols-light_cancel-outline-rounded.svg" alt="">
        </div>

      </div>
    </div>
    <div class="social_link_main_div">
      <div class="offer-main-div">
        <div class="offer-sub-div">
          <input type="checkbox" name="" id="" class="inp_checkox_time"
            (change)="socialLinkHandelFunc('insta', $event.target)" [(checked)]="instagramCon"
            [disabled]="cIsEditDisabledFlag.socialLink">
          <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/Instagram-Logo.wine.svg"
              alt="" srcset="" style="max-width: 65px;">
            Instagram </div>
        </div>
        <div class="offer-sub-div" *ngIf="instagramCon">
          <div *ngIf="cIsEditDisabledFlag.socialLink"
            style="margin-top: 10px; font-size: 16px; color: rgb(51 51 249); cursor: pointer;"
            (click)="openLink(instagramVal)">
            <span>{{instagramVal}}</span>
          </div>
          <input type="url" name="" id="" class="inp_costum" style="margin: auto 0;" [(ngModel)]="instagramVal"
            placeholder="Please enter the url" [disabled]="cIsEditDisabledFlag.socialLink"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.socialLink}"
            *ngIf="!cIsEditDisabledFlag.socialLink">
        </div>
        <div *ngIf="!failToFetchDataFlag && !instagramCon && !this.openAiRestoInfo['Social links']['Instagram']"
          style="margin-top: 10px; font-size: 16px; color: #555252 ;">
          <span>Unable to fetch the data. Click edit to enter url.</span>
        </div>
      </div>
      <div class="offer-main-div">
        <div class="offer-sub-div">
          <input type="checkbox" name="" id="" class="inp_checkox_time"
            (change)="socialLinkHandelFunc('facebook', $event.target)" [(checked)]="facebookCon"
            [disabled]="cIsEditDisabledFlag.socialLink">
          <div class="cuisine-name" style="margin-top: 0;"> <img
              src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset="" style="max-width: 65px;">
            Facebook </div>
        </div>
        <div class="offer-sub-div" *ngIf="facebookCon">

          <div *ngIf="cIsEditDisabledFlag.socialLink"
            style="margin-top: 10px; font-size: 16px; color: rgb(51 51 249); cursor: pointer;"
            (click)="openLink(facebookVal)">
            <span>{{facebookVal}}</span>
          </div>
          <input type="url" name="" id="" class="inp_costum" style="margin: auto 0;" [(ngModel)]="facebookVal"
            placeholder="Please enter the url" [disabled]="cIsEditDisabledFlag.socialLink"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.socialLink}"
            *ngIf="!cIsEditDisabledFlag.socialLink">
        </div>

        <div *ngIf="!failToFetchDataFlag && !facebookCon && !this.openAiRestoInfo['Social links']['Facebook']"
          style="margin-top: 10px; font-size: 16px; color: #555252 ;">
          <span>Unable to fetch the data. Click edit to enter url.</span>
        </div>
      </div>
      <div class="offer-main-div">
        <div class="offer-sub-div">
          <input type="checkbox" name="" id="" class="inp_checkox_time"
            (change)="socialLinkHandelFunc('google-map', $event.target)" [(checked)]="googleMapCon"
            [disabled]="cIsEditDisabledFlag.socialLink">
          <div class="cuisine-name" style="margin-top: 0;"> <img
              src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset="" style="max-width: 65px;">
            Google Map </div>
        </div>
        <div class="offer-sub-div" *ngIf="googleMapCon">
          <div *ngIf="cIsEditDisabledFlag.socialLink"
            style="margin-top: 10px; font-size: 16px; color: rgb(51 51 249);; cursor: pointer;"
            (click)="openLink(googleMapVal)">
            <span>{{googleMapVal}}</span>
          </div>

          <input type="url" name="" id="" class="inp_costum" style="margin: auto 0;" [(ngModel)]="googleMapVal"
            placeholder="Please enter the url" [disabled]="cIsEditDisabledFlag.socialLink"
            [ngClass]="{inp_costum_edit_enabled:!cIsEditDisabledFlag.socialLink}"
            *ngIf="!cIsEditDisabledFlag.socialLink">
        </div>
        <div *ngIf="!failToFetchDataFlag && !googleMapCon && !this.openAiRestoInfo['Google Map location']"
          style="margin-top: 10px; font-size: 16px; color: #555252 ;">
          <span>Unable to fetch the data. Click edit to enter url.</span>
        </div>
      </div>
    </div>
  </div>



  <div class="claim_resto_main_div">
    <button class="cliam_button" (click)="claimResto()">
      {{failToFetchDataFlag ? 'CLAIM' : 'UPDATE'}}
    </button>
  </div>


  <div style="height: 4rem;">
    &nbsp;
  </div>

</div>



<style>
  .claim_resto_main_div {
    margin-top: 1rem;
    text-align: center;
    position: sticky;
    bottom: 10px;
    display: inline-block;
    left: calc(50vw - 120px);
  }

  .cl_card_main_div {
    background: #F6F6F6;
    border-radius: 12px;
    margin-bottom: 2rem;

    .cl_card_heading {
      background: #2E8198;
      border-radius: 12px 12px 0 0;
      height: 42px;
      color: white;
      font-size: 16px;
      font-weight: 600;
      font-family: 'Inter', sans-serif;
      display: flex;
      align-items: center;
      padding: 0 2rem;
      justify-content: space-between;

      span {
        text-transform: capitalize;
      }

    }

    .cl_card_body {
      padding: 1rem 2rem;
    }

    .cl_grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 3rem;
    }
  }

  .cl_label_heading {
    color: #2E8198;
    font-size: 16px;
    font-family: 'IBM Plex Sans', sans-serif;
  }

  .inp_costum {
    background: transparent;
    border: none;
    outline: none;
    font-size: 16px;
    caret-color: #4594AA;
    zoom: 1.01;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
  }

  .inp_costum:disabled {
    color: #555252 !important;
  }

  .inp_costum_edit_enabled {
    border-bottom: 1px solid #2E8198 !important;
  }

  textarea[matInput] {
    overflow: hidden !important;
    resize: none !important;
    box-sizing: border-box;
    line-height: 1.5;
  }

  .mt_18 {
    margin-top: 18px;
  }


  .inp_checkox_time {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #BCBCBC;
    border-radius: 3px;
    background-color: #fff;
    cursor: pointer;
    position: relative;
  }

  /* Tick mark when checked */
  .inp_checkox_time:checked::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 10px;
    border: solid #2E8198;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  /* Disabled styling (same design, just no click) */
  .inp_checkox_time:disabled {
    background-color: #fff;
    border: 2px solid #BCBCBC;
    cursor: not-allowed;
    opacity: 1;
    /* Prevent greying */
  }

  /* Tick mark still visible even when disabled */
  .inp_checkox_time:disabled:checked::after {
    border-color: #2E8198;
  }

  .container_img_slider_div {
    height: 370px;
    width: 100%;

  }

  .cl_quick_btn_main_div {
    display: flex;
    gap: 30px;
    justify-content: flex-end;
  }

  .cl_quick_btn_div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
  }

  .cl_quick_btn_disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .cl_logo_btn_upload {
    outline: none;
    width: 124px;
    height: 39px;
    background: #54AC58;
    border: 1px solid #54AC58;
    border-radius: 35pc;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
  }


  .cl_resto_logo {
    height: 120px;
    width: 120px;
    border-radius: 50%;
    overflow: hidden;
    background: transparent;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }



  .cliam_button {
    width: 240px;
    height: 51px;
    outline: none;
    border: none;
    border-radius: 104px;
    background-color: #2E8198;
    color: #F8F8F8;
    font-weight: 600;
    font-size: 16px;
    font-family: 'Inter', sans-serif;
  }

  .loader_3_line_main_div {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 12px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    color: #757575;

    .loader_3_line_circle {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #B1B1B1;
    }
  }


  .container_img_slider_div {
    position: relative;
    overflow: hidden;
  }

  .upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    /* semi-transparent overlay */
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 10px;
  }

  .container_img_slider_div:hover .upload-overlay {
    opacity: 1;
  }

  .upload-btn {
    padding: 10px 20px;
    font-weight: bold;
    background-color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    border-radius: 35px;
    width: 124px;
    color: #1A657A;
  }
</style>


































<div style="display: none;">
  <div style="width: 100vw;">
    <div>
      <img src="../../../assets/images/header.png" alt="" width="100%" class="headLogoImg">
    </div>
    <div *ngIf="!last">
      <h2 class="heading-top">Fill all the information to add your restaurant to foodbud</h2>

      <div class="sub-mainDiv">
        <div class="side-div ">
          <div class="profile-section">
            <img [src]="src" alt="" style="width: 50px;">
            <div>
              <h3 style="text-transform: uppercase;">{{selctedName}}</h3>
              <span>{{selctedEmail}}</span>
            </div>
          </div>
          <div class="side-details" [ngClass]="{'selected-bg':restoDetailsCondition}"
            (click)="restoDetailsCondition = true">
            <img src="../../../assets/images/1-active.svg" alt="" *ngIf="restoDetailsCondition">
            <img src="../../../assets/images/1-inactive.svg" alt="" *ngIf="!restoDetailsCondition">
            <span>Basic Details</span>
          </div>
          <div class="side-details" [ngClass]="{'selected-bg':!restoDetailsCondition}"
            (click)="restoDetailsCondition = false">
            <img src="../../../assets/images/2-active.svg" alt="" *ngIf="!restoDetailsCondition">
            <img src="../../../assets/images/2-inactive.svg" alt="" *ngIf="restoDetailsCondition">
            <span>Advanced Details</span>
          </div>
        </div>

        <div style="flex: 1;" *ngIf="restoDetailsCondition">
          <div class="mobile-side-div">
            <div class="side-details mobile-side-deatils" [ngClass]="{'selected-bg':restoDetailsCondition}"
              (click)="restoDetailsCondition = true">
              <img src="../../../assets/images/1-active.svg" alt="" *ngIf="restoDetailsCondition">
              <img src="../../../assets/images/1-inactive.svg" alt="" *ngIf="!restoDetailsCondition">
              <span>Basic Details</span>
            </div>
            <div class="side-details mobile-side-deatils" [ngClass]="{'selected-bg':!restoDetailsCondition}"
              (click)="restoDetailsCondition = false">
              <img src="../../../assets/images/2-active.svg" alt="" *ngIf="!restoDetailsCondition">
              <img src="../../../assets/images/2-inactive.svg" alt="" *ngIf="restoDetailsCondition">
              <span>Advanced Details</span>

            </div>
          </div>
          <div class="text-head"> Restaurant Details</div>
          <span class="heading-subDel">(please fill all the required information below)</span>
          <div class="details-mainCon">
            <div class="first-form-div">
              <div>
                <label for="" class="m-t-20">Restaurant Name</label>
                <input type="text" spellcheck="false" class="form-control" [(ngModel)]="restoName" id="restoName">
              </div>
              <div class="p-l-20">
                <label for="restoName" class="m-t-20">Restaurant Logo (optional) <br> (less than 500kb)</label>
                <div style="display: flex; align-items:center;">
                  <span class="imgPreview"><img [src]="src" alt="" style="border-radius: 50%;" /></span>
                  <span>
                    <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event, 'claimLogo')"
                      #fileInput_image hidden name="imgFile" id="claimLogo" />
                    <button class="uploadBtn" (click)="fileInput_image.click()">
                      <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                    </button>
                  </span>

                </div>
              </div>
            </div>
            <div class="second-form-div">
              <div>
                <label for="" class="m-t-20">Your official or admin email address</label>
                <input type="email" class="form-control" [readonly]="readOnlyEmailCondition" [(ngModel)]="restoEmail"
                  id="restoOfficalEmail">
              </div>
              <div style="display: flex;flex-direction: column;justify-content: space-between;">
                <label for="" class="m-t-20">Restaurant Telephone</label>
                <input type="text" (keypress)="validateNum($event)" class="form-control" [(ngModel)]="restoPhone"
                  id="restoOfficalPhone">
              </div>
            </div>
            <div>
              <label for="" class="m-t-20">Restaurant Address</label>
              <textarea class="form-control" rows="3" [(ngModel)]="restoAddress" id="restoOfficalAddress"></textarea>
            </div>
            <div>
              <label for="" class="m-t-20">Upload a nice picture of outlet in JPEG or PNG (optional)<br>(less than
                500kb)</label><br>
              <div *ngIf="featureSrc != 'null'" class="feature-img-priview">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start;">
                  <img [src]="featureSrc" alt="" style="width: 30%;">
                  <img src="../../../assets/images/Cancel.png" alt=""
                    style="position: relative; top: -6px;right: 14px; cursor: pointer;"
                    (click)="deleteFeatureImgFunc()">
                </div>
                <div>
                  <div class="addBtn-mainDiv" style="margin-left: 10px;" (click)="fileInput_Feature_image.click()">
                    <input type="file" accept="image/png,image/jpeg"
                      (change)="onFeatureImgChange($event,'claimedFeatureImg')" #fileInput_Feature_image hidden
                      name="imgFile" id="claimedFeatureImg" />
                    <span>Change</span>
                  </div>
                </div>
              </div>
              <div class="addBtn-mainDiv" (click)="fileInput_Feature_image.click()" *ngIf="featureSrc == 'null'">
                <input type="file" accept="image/png,image/jpeg"
                  (change)="onFeatureImgChange($event,'claimedFeatureImgAdd')" #fileInput_Feature_image hidden
                  name="imgFile" id="claimedFeatureImgAdd" />
                <img src="../../../assets/images/upLogo.png" alt="">
                <span>Add file</span>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------------- -->
        <div style="flex: 1; width:-webkit-fill-available" *ngIf="!restoDetailsCondition">
          <div class="mobile-side-div">
            <div class="side-details mobile-side-deatils" [ngClass]="{'selected-bg':restoDetailsCondition}"
              (click)="restoDetailsCondition = true">
              <img src="../../../assets/images/1-active.svg" alt="" *ngIf="restoDetailsCondition">
              <img src="../../../assets/images/1-inactive.svg" alt="" *ngIf="!restoDetailsCondition">
              <span>Basic Details</span>
            </div>
            <div class="side-details mobile-side-deatils" [ngClass]="{'selected-bg':!restoDetailsCondition}"
              (click)="restoDetailsCondition = false">
              <img src="../../../assets/images/2-active.svg" alt="" *ngIf="!restoDetailsCondition">
              <img src="../../../assets/images/2-inactive.svg" alt="" *ngIf="restoDetailsCondition">
              <span>Advanced Details</span>
            </div>

          </div>
          <div class="text-head"> Menu Details</div>
          <span class="heading-subDel">(please fill all the required information below)</span>
          <div class="details-mainCon" id="menuMainDiv">
            <div>
              <label for="">1. Upload your menu in pdf or jpeg form or an online url<br>(image should be less than
                500kb)</label>
              <div *ngIf="menuSrc.length != 0" class="menu-img-preview-main">
                <div *ngFor="let item of menuSrc; let i =index"
                  style="width: 30%;margin-right: 10px; margin-bottom: 20px;display: flex;align-items: flex-start;">
                  <img [src]="item.src" alt="">
                  <img src="../../../assets/images/Cancel.png" alt=""
                    style="position: relative; top: -6px;right: 14px; cursor: pointer;" (click)="deleteImg(item)">
                </div>
                <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
                  <input type="file" accept="image/png,image/jpeg,application/pdf"
                    (change)="onMenuChange($event, 'menuImgDelete1')" #fileInput_Menu_image hidden name="imgFile"
                    id="menuImgDelete1" />
                  <img src="../../../assets/images/upLogo.png" alt="">
                  <span>Add file</span>
                </div>
              </div>
              <div *ngIf="pdfMenuSrc != 'null' && menuSrc.length == 0 ">
                <span class="pdfMainSpan">
                  <img src="../../../assets/img/pdf-icon.png" alt="" (click)="openpdf()">
                  <span style="overflow-wrap: anywhere; margin: auto 0;" (click)="openpdf()">{{pdfMenuSrc}}</span>
                  <img src="../../../assets/img/close-red-icon.png" alt=""
                    style="width: 17px;height: 17px;margin:auto 0; cursor:pointer" (click)="pdfDelete()">
                </span>
              </div>
              <div class="menu-first-div" *ngIf="menuSrc.length == 0 && pdfMenuSrc == 'null'">
                <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
                  <input type="file" accept="image/png,image/jpeg,application/pdf"
                    (change)="onMenuChange($event,'menuImgDelete2')" #fileInput_Menu_image hidden name="imgFile"
                    id="menuImgDelete2" />
                  <img src="../../../assets/images/upLogo.png" alt="">
                  <span>Add file</span>
                </div>
                <div>or</div>
                <div class="addBtn-mainDiv" (click)="menuLinkInsert()">
                  <img src="../../../assets/images/insert.png" alt="">
                  <span>Insert Url</span>
                </div>

              </div>
              <div *ngIf="menuLinkCondition">
                <div style="font-size: 16px; line-height: 23px; color: #737373;">Please enter the url</div>
                <input type="url" name="" id="" class="form-control" style="width: 50%;" spellcheck="false"
                  [(ngModel)]="urlLink">
              </div>
            </div>
          </div>
          <div class="details-mainCon">
            <label for="">2. Select your Cuisine type applicable to your restaurant (You may select multiple
              options)</label>
            <div class="cuisine-div" id="cuisine">
              <div *ngFor="let item of allCuisine" style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input "
                  [checked]="preSelectFunc('cuisines',item.id)"
                  (change)="cuisineCheckedUncheckedFunc($event.target, item.id)">
                <div class="cuisine-name"> {{item.name}}</div>
              </div>
            </div>
            <div class="deselect-btn">
              <div (click)="deselect('cuisine')" style="cursor: pointer;">Deselect all</div>
            </div>
          </div>
          <div class="details-mainCon" style="padding-left: 0px;">
            <label for="" style="padding-left: 20px;">3. Select your food Categories applicable to your restaurant
              (You
              may select multiple
              options)</label>
            <div *ngFor="let items of allCaategory">
              <div style="color: gray;font-size: 18px;margin: 10px 0px;background: whitesmoke;padding: 10px;">
                {{items.type}} </div>
              <div class="cuisine-div" id="categories" style="padding-left: 20px;">
                <div *ngFor="let item of items.category" style="display: flex; margin-bottom :15px;">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    [checked]="preSelectFunc('categories',item.category_id)"
                    (change)="catCheckedUncheckedFunc($event.target, item.category_id)">
                  <div class="cuisine-name"> {{item.category_name}}</div>
                </div>
              </div>
            </div>
            <div class="deselect-btn">
              <div (click)="deselect('categories')" style="cursor: pointer;">Deselect all</div>
            </div>
          </div>
          <div class="details-mainCon">
            <label for="">4. Select the Dietary preference that you currently cater to</label>
            <div class="cuisine-div" id="dietPref">
              <div *ngFor="let item of allDieatary" style="display: flex; margin-bottom :15px;">
                <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  [checked]="preSelectFunc('dietPref',item.id)"
                  (change)="dpCheckedUncheckedFunc($event.target, item.id)">
                <div class="cuisine-name"> {{item.name}}</div>
              </div>
            </div>
            <div class="deselect-btn">
              <div (click)="deselect('dietPref')" style="cursor: pointer;">Deselect all</div>
            </div>
          </div>
          <div class="details-mainCon remove-padding" id="openingClosingMainDiv">
            <label for="">5. Verify your opening and closing hours</label>
            <div class="bigScreen">
              <div style="margin-left: 15px; display: grid;grid-template-columns: 1fr 1fr 1fr 2fr;">
                <div class="time-text">Days</div>
                <div class="time-text">Open/Close</div>
                <div class="time-text">Open timings</div>
                <div class="time-text">Close timings</div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('mondayTime',$event.target)" [checked]="timePreCheck('mon')"> -->
                  <div class="cuisine-name m-l-0"> Monday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="monClearCondition ? 'mondayTime:true':'mondayTime:false'">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
                <div id="mondayTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="monOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="mondayTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="monCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <span (click)="timeClear('mondayTime')" class="clear-timeBtn" *ngIf="monClearCondition">Clear</span>
                </div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('tuesdayTime',$event.target)" [checked]="timePreCheck('tue')"> -->
                  <div class="cuisine-name m-l-0"> Tuesday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="monClearCondition ? 'tuesdayTime:true':'tuesdayTime:false'">
                    <option value="tuesdayTime:true" selected>Open</option>
                    <option value="tuesdayTime:false">Close</option>
                  </select>
                </div>
                <div id="tuesdayTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="tueOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="tuesdayTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="tueCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <div class="clear-copyDiv">
                    <span (click)="timeClear('tuesdayTime')" class="clear-timeBtn"
                      *ngIf="tueClearCondition">Clear</span>
                    <div
                      *ngIf="tueClearCondition && monOpenHH !='' && monOpenMM!='' && monCloseHH !='' && monCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="tueClearCondition && monOpenHH !='' && monOpenMM!='' && monCloseHH !='' && monCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('tue')">
                      Copy
                    </button>
                  </div>
                </div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('wednesTime',$event.target)" [checked]="timePreCheck('wed')"> -->
                  <div class="cuisine-name m-l-0"> Wednesday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="wedClearCondition ? 'wednesTime:true':'wednesTime:false'">
                    <option value="wednesTime:true" selected>Open</option>
                    <option value="wednesTime:false">Close</option>
                  </select>
                </div>
                <div id="wednesTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="wedOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="wednesTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="wedCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <div class="clear-copyDiv">
                    <span (click)="timeClear('wednesTime')" class="clear-timeBtn" *ngIf="wedClearCondition">Clear</span>
                    <div
                      *ngIf="wedClearCondition && tueOpenHH !='' && tueOpenMM!='' && tueCloseHH !='' && tueCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="wedClearCondition && tueOpenHH !='' && tueOpenMM!='' && tueCloseHH !='' && tueCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('wed')">
                      Copy
                    </button>
                  </div>
                </div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('thursdayTime',$event.target)" [checked]="timePreCheck('thu')"> -->
                  <div class="cuisine-name m-l-0"> Thursday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="thurClearCondition ? 'thursdayTime:true':'thursdayTime:false'">
                    <option value="thursdayTime:true" selected>Open</option>
                    <option value="thursdayTime:false">Close</option>
                  </select>
                </div>
                <div id="thursdayTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="thurOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="thursdayTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                    [(ngModel)]="thurCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                    [(ngModel)]="thurCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="thurCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <div class="clear-copyDiv">
                    <span (click)="timeClear('thursdayTime')" class="clear-timeBtn"
                      *ngIf="thurClearCondition">Clear</span>
                    <div
                      *ngIf="thurClearCondition && wedOpenHH !='' && wedOpenMM!='' && wedCloseHH !='' && wedCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="thurClearCondition && wedOpenHH !='' && wedOpenMM!='' && wedCloseHH !='' && wedCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('thur')">
                      Copy
                    </button>
                  </div>
                </div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('fridayTime',$event.target)" [checked]="timePreCheck('fri')"> -->
                  <div class="cuisine-name m-l-0"> Friday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="friClearCondition ? 'fridayTime:true':'fridayTime:false'">
                    <option value="fridayTime:true" selected>Open</option>
                    <option value="fridayTime:false">Close</option>
                  </select>
                </div>
                <div id="fridayTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="friOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="fridayTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="friCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>

                  <div class="clear-copyDiv">
                    <span (click)="timeClear('fridayTime')" class="clear-timeBtn" *ngIf="friClearCondition">Clear</span>
                    <div
                      *ngIf="friClearCondition && thurOpenHH !='' && thurOpenMM!='' && thurCloseHH !='' && thurCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="friClearCondition && thurOpenHH !='' && thurOpenMM!='' && thurCloseHH !='' && thurCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('fri')">
                      Copy
                    </button>
                  </div>
                </div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('saturdayTime',$event.target)" [checked]="timePreCheck('sat')"> -->
                  <div class="cuisine-name m-l-0"> Saturday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="satClearCondition ? 'saturdayTime:true':'saturdayTime:false'">
                    <option value="saturdayTime:true" selected>Open</option>
                    <option value="saturdayTime:false">Close</option>
                  </select>
                </div>
                <div id="saturdayTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="satOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="saturdayTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="satCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <div class="clear-copyDiv">
                    <span (click)="timeClear('saturdayTime')" class="clear-timeBtn"
                      *ngIf="satClearCondition">Clear</span>
                    <div
                      *ngIf="satClearCondition && friOpenHH !='' && friOpenMM!='' && friCloseHH !='' && friCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="satClearCondition && friOpenHH !='' &&friOpenMM!='' && friCloseHH !='' && friCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sat')">
                      Copy
                    </button>
                  </div>
                </div>
                <div style="display: flex; margin-bottom :15px;">
                  <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                  (change)="timeInputFunc('sundayTime',$event.target)" [checked]="timePreCheck('sun')"> -->
                  <div class="cuisine-name m-l-0"> Sunday </div>
                </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-bigScreen"
                    (change)="timeInputFunc($event.target.value)"
                    [value]="sunClearCondition ? 'sundayTime:true':'sundayTime:false'">
                    <option value="sundayTime:true" selected>Open</option>
                    <option value="sundayTime:false">Close</option>
                  </select>
                </div>
                <div id="sundayTimeOpen">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="sunOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="sundayTimeClose">
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="sunCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <div class="clear-copyDiv">
                    <span (click)="timeClear('sundayTime')" class="clear-timeBtn" *ngIf="sunClearCondition">Clear</span>
                    <div
                      *ngIf="sunClearCondition && satOpenHH !='' && satOpenMM!='' && satCloseHH !='' && satCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="sunClearCondition && satOpenHH !='' && satOpenMM!='' && satCloseHH !='' && satCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sun')">
                      Copy
                    </button>
                  </div>
                </div>

              </div>

            </div>
            <div class="smallScreen">


              <div style="display: flex; margin-bottom :15px;">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('mondayTime',$event.target)"> -->
                <div class="cuisine-name m-l-0"> Monday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="mondayTimeOpenSmall">
                  <div class="time-text">Open timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monOpenHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monOpenMM" />
                  <select class="time-selectOption" [(ngModel)]="monOpenMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                </div>
                <div id="mondayTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="monCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <span (click)="timeClear('mondayTime')" class="clear-timeBtn smallScreen-clear-timeBtn copyImg-1"
                    *ngIf="monClearCondition">Clear</span>
                  <img src="../../../assets/img/clear.svg" (click)="timeClear('mondayTime')"
                    class="clear-timeBtn smallScreen-clear-timeBtn copyImg-2" *ngIf="monClearCondition"
                    style="width: 20px; margin: 0px;" />
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;" class="m-t-10">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('tuesdayTime',$event.target)"> -->
                <div class="cuisine-name m-l-0"> Tuesday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="tuesdayTimeOpenSmall" class="flex-wrap-fill-all">
                  <div class="time-text">Open timings</div>
                  <div>
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                      [(ngModel)]="tueOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="tueOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="tueOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                </div>
                <div id="tuesdayTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="tueCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <!-- <span (click)="timeClear('tuesdayTime')" class="clear-timeBtn"
                  *ngIf="tuesdayClearCondition">Clear</span> -->
                  <div class="clear-copyDiv copyDiv-1">
                    <span (click)="timeClear('tuesdayTime')" class="clear-timeBtn"
                      *ngIf="tueClearCondition">Clear</span>
                    <div
                      *ngIf="tueClearCondition && monOpenHH !='' && monOpenMM!='' && monCloseHH !='' && monCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="tueClearCondition && monOpenHH !='' && monOpenMM!='' && monCloseHH !='' && monCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('tue')">
                      Copy
                    </button>
                  </div>
                  <div class="clear-copyDiv copyDiv-2">
                    <img src="../../../assets/img/clear.svg" alt="close" style="width: 20px;"
                      (click)="timeClear('tuesdayTime')" *ngIf="tueClearCondition" />
                    <div
                      *ngIf="tueClearCondition && monOpenHH !='' && monOpenMM!='' && monCloseHH !='' && monCloseMM!=''">
                      |</div>
                    <span
                      *ngIf="tueClearCondition && monOpenHH !='' && monOpenMM!='' && monCloseHH !='' && monCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" (click)="copyTimeFunc('tue')">
                      Copy
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;" class="m-t-10">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('wednesTime',$event.target)"> -->
                <div class="cuisine-name m-l-0"> Wednesday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="wednesTimeOpenSmall " class="flex-wrap-fill-all">
                  <div class="time-text">Open timings</div>
                  <div>
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                      [(ngModel)]="wedOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="wedOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="wedOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                </div>
                <div id="wednesTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="wedCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <!-- <span (click)="timeClear('wednesTime')" class="clear-timeBtn"
                  *ngIf="wednesdayClearCondition">Clear</span> -->
                  <div class="clear-copyDiv copyDiv-1">
                    <span (click)="timeClear('wednesTime')" class="clear-timeBtn" *ngIf="wedClearCondition">Clear</span>
                    <div
                      *ngIf="wedClearCondition && tueOpenHH !='' && tueOpenMM!='' && tueCloseHH !='' && tueCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="wedClearCondition && tueOpenHH !='' && tueOpenMM!='' && tueCloseHH !='' && tueCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('wed')">
                      Copy
                    </button>
                  </div>
                  <div class="clear-copyDiv copyDiv-2">
                    <img src="../../../assets/img/clear.svg" alt="close" style="width: 20px;"
                      src="../../../assets/img/clear.svg" alt="close" style="width: 20px;" an
                      (click)="timeClear('wednesTime')" *ngIf="wedClearCondition" />
                    <div
                      *ngIf="wedClearCondition && tueOpenHH !='' && tueOpenMM!='' && tueCloseHH !='' && tueCloseMM!=''">
                      |</div>
                    <span
                      *ngIf="wedClearCondition && tueOpenHH !='' && tueOpenMM!='' && tueCloseHH !='' && tueCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-span" (click)="copyTimeFunc('wed')">
                      Copy
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;" class="m-t-10">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('thursdayTime',$event.target)"> -->
                <div class="cuisine-name m-l-0"> Thursday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="thursdayTimeOpenSmall" class="flex-wrap-fill-all">
                  <div class="time-text">Open timings</div>
                  <div>
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                      [(ngModel)]="thurOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="thurOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="thurOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                </div>
                <div id="thursdayTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                    [(ngModel)]="thurCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                    [(ngModel)]="thurCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="thurCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <!-- <span (click)="timeClear('thursdayTime')" class="clear-timeBtn"
                  *ngIf="tursdayClearCondition">Clear</span> -->
                  <div class="clear-copyDiv copyDiv-1">
                    <span (click)="timeClear('thursdayTime')" class="clear-timeBtn"
                      *ngIf="thurClearCondition">Clear</span>
                    <div
                      *ngIf="thurClearCondition && wedOpenHH !='' && wedOpenMM!='' && wedCloseHH !='' && wedCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="thurClearCondition && wedOpenHH !='' && wedOpenMM!='' && wedCloseHH !='' && wedCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('thur')">
                      Copy
                    </button>
                  </div>
                  <div class="clear-copyDiv copyDiv-2">
                    <img src="../../../assets/img/clear.svg" alt="close" style="width: 20px;"
                      (click)="timeClear('thursdayTime')" *ngIf="thurClearCondition" />
                    <div
                      *ngIf="thurClearCondition && wedOpenHH !='' && wedOpenMM!='' && wedCloseHH !='' && wedCloseMM!=''">
                      |</div>
                    <span
                      *ngIf="thurClearCondition && wedOpenHH !='' && wedOpenMM!='' && wedCloseHH !='' && wedCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-span" (click)="copyTimeFunc('thur')">
                      Copy
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;" class="m-t-10">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('fridayTime',$event.target)"> -->
                <div class="cuisine-name m-l-0"> Friday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="fridayTimeOpenSmall" class="flex-wrap-fill-all">
                  <div class="time-text">Open timings</div>
                  <div>
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                      [(ngModel)]="friOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="friOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="friOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                </div>
                <div id="fridayTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="friCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <!-- <span (click)="timeClear('fridayTime')" class="clear-timeBtn" *ngIf="fridayClearCondition">Clear</span> -->
                  <div class="clear-copyDiv copyDiv-1">
                    <span (click)="timeClear('fridayTime')" class="clear-timeBtn" *ngIf="friClearCondition">Clear</span>
                    <div
                      *ngIf="friClearCondition && thurOpenHH !='' && thurOpenMM!='' && thurCloseHH !='' && thurCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="friClearCondition && thurOpenHH !='' && thurOpenMM!='' && thurCloseHH !='' && thurCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('fri')">
                      Copy
                    </button>
                  </div>
                  <div class="clear-copyDiv copyDiv-2">
                    <img src="../../../assets/img/clear.svg" alt="close" style="width: 20px;"
                      (click)="timeClear('fridayTime')" *ngIf="friClearCondition" />
                    <div
                      *ngIf="friClearCondition && thurOpenHH !='' && thurOpenMM!='' && thurCloseHH !='' && thurCloseMM!=''">
                      |</div>
                    <span
                      *ngIf="friClearCondition && thurOpenHH !='' && thurOpenMM!='' && thurCloseHH !='' && thurCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-span" (click)="copyTimeFunc('fri')">
                      Copy
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;" class="m-t-10">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('saturdayTime',$event.target)"> -->
                <div class="cuisine-name m-l-0"> Saturday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="saturdayTimeOpenSmall" class="flex-wrap-fill-all">
                  <div class="time-text">Open timings</div>
                  <div>
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                      [(ngModel)]="satOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="satOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="satOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                </div>
                <div id="saturdayTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="satCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <!-- <span (click)="timeClear('saturdayTime')" class="clear-timeBtn"
                  *ngIf="saturdayClearCondition">Clear</span> -->
                  <div class="clear-copyDiv copyDiv-1">
                    <span (click)="timeClear('saturdayTime')" class="clear-timeBtn"
                      *ngIf="satClearCondition">Clear</span>
                    <div
                      *ngIf="satClearCondition && friOpenHH !='' && friOpenMM!='' && friCloseHH !='' && friCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="satClearCondition && friOpenHH !='' &&friOpenMM!='' && friCloseHH !='' && friCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sat')">
                      Copy
                    </button>
                  </div>
                  <div class="clear-copyDiv copyDiv-2">
                    <img src="../../../assets/img/clear.svg" alt="close" style="width: 20px;"
                      (click)="timeClear('saturdayTime')" *ngIf="satClearCondition" />
                    <div
                      *ngIf="satClearCondition && friOpenHH !='' && friOpenMM!='' && friCloseHH !='' && friCloseMM!=''">
                      |</div>
                    <span
                      *ngIf="satClearCondition && friOpenHH !='' &&friOpenMM!='' && friCloseHH !='' && friCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-span" (click)="copyTimeFunc('sat')">
                      Copy
                    </span>
                  </div>
                </div>
              </div>
              <div style="display: flex; margin-bottom :15px;" class="m-t-10">
                <!-- <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                (change)="timeInputFunc('sundayTime',$event.target)" [checked]="sunPrecheck"> -->
                <div class="cuisine-name m-l-0"> Sunday </div>
                <div>
                  <select name="" id="" class="form-select open-close-select-smallScreen"
                    (change)="timeInputFunc($event.target.value)">
                    <option value="mondayTime:true" selected>Open</option>
                    <option value="mondayTime:false">Close</option>
                  </select>
                </div>
              </div>
              <div class="smallTimeSubDiv">
                <div id="sundayTimeOpenSmall" class="flex-wrap-fill-all">
                  <div class="time-text">Open timings</div>
                  <div>
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH"
                      [(ngModel)]="sunOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="sunOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="sunOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                </div>
                <div id="sundayTimeCloseSmall">
                  <div class="time-text">Close timings</div>
                  <input name="" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunCloseHH" />
                  <span>:</span>
                  <input name="somename" class="time-input"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                    type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunCloseMM" />
                  <select class="time-selectOption" [(ngModel)]="sunCloseMead">
                    <option value="am" selected>AM</option>
                    <option value="pm">PM</option>
                  </select>
                  <!-- <span (click)="timeClear('sundayTime')" class="clear-timeBtn"
                  *ngIf="sundayClearCondition">Clear</span> -->
                  <div class="clear-copyDiv copyDiv-1">
                    <span (click)="timeClear('sundayTime')" class="clear-timeBtn" *ngIf="sunClearCondition">Clear</span>
                    <div
                      *ngIf="sunClearCondition && satOpenHH !='' && satOpenMM!='' && satCloseHH !='' && satCloseMM!=''">
                      |</div>
                    <button
                      *ngIf="sunClearCondition && satOpenHH !='' && satOpenMM!='' && satCloseHH !='' && satCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sun')">
                      Copy
                    </button>
                  </div>
                  <div class="clear-copyDiv copyDiv-2">
                    <img src="../../../assets/img/clear.svg" alt="close" style="width: 20px;"
                      (click)="timeClear('sundayTime')" *ngIf="sunClearCondition" />
                    <div
                      *ngIf="sunClearCondition && satOpenHH !='' && satOpenMM!='' && satCloseHH !='' && satCloseMM!=''">
                      |</div>
                    <span
                      *ngIf="sunClearCondition && satOpenHH !='' && satOpenMM!='' && satCloseHH !='' && satCloseMM!=''   "
                      mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                      [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                      aria-label="Copy time from previous day" class="example-span" (click)="copyTimeFunc('sun')">
                      Copy
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="details-mainCon" id="specialOffer">
            <label for="">6. If you run any special events or offers on specific days of week please provide here. It
              will
              help new customers discover you on those days</label>
            <div class="time-text">Select days</div>
            <div style="margin-left: 15px;">
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('mon',$event.target)" [(checked)]="offerMonday">
                  <div class="cuisine-name"> Monday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerMonday">Offer Discount (%)</div> -->
                  <div *ngIf="offerMonday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerMonValue">
                  </div>
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('tue',$event.target)" [(checked)]="offerTuesday">
                  <div class="cuisine-name"> Tuesday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerTuesday">Offer Discount (%)</div> -->
                  <div *ngIf="offerTuesday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerTueValue">
                  </div>
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('wed',$event.target)" [(checked)]="offerWednesday">
                  <div class="cuisine-name"> Wednesday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerWednesday">Offer Discount (%)</div> -->
                  <div *ngIf="offerWednesday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerWedValue">
                  </div>
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('thu',$event.target)" [(checked)]="offerTurusday">
                  <div class="cuisine-name"> Thursday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerTurusday">Offer Discount (%)</div> -->
                  <div *ngIf="offerTurusday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerThurValue">
                  </div>
                </div>

              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('fri',$event.target)" [(checked)]="offerFriday">
                  <div class="cuisine-name"> Friday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerFriday">Offer Discount (%)</div> -->
                  <div *ngIf="offerFriday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerFriValue">
                  </div>
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('sat',$event.target)" [(checked)]="offerSaturday">
                  <div class="cuisine-name"> Saturday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerSaturday">Offer Discount (%)</div> -->
                  <div *ngIf="offerSaturday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerSatValue">
                  </div>
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="offerHandelFunc('sun',$event.target)" [(checked)]="offerSunday">
                  <div class="cuisine-name"> Sunday </div>
                </div>
                <div class="offer-sub-div">
                  <!-- <div class="offer-div" *ngIf="offerSunday">Offer Discount (%)</div> -->
                  <div *ngIf="offerSunday">
                    <label for="" class="special-offer-label">Description of special event/discount</label>
                    <input type="text" placeholder="Eg. 10% or Pub quiz" name="" id=""
                      class="form-control specailOfferInput" [(ngModel)]="offerSunValue">
                  </div>
                </div>
              </div>
            </div>
            <div class="deselect-btn">
              <div (click)="deselectOffer()" style="cursor: pointer;">Deselect all</div>
            </div>
          </div>
          <div class="details-mainCon" id="allergyMessage">
            <label for="">7. Please select an appropriate food allergy message for your customers</label>
            <div style="margin-left: 15px;">
              <div style="margin-bottom: 15px;">
                <input type="radio" name="allergenMsg" id="" value="a" class="form-radio form-check-input"
                  (change)="queAns = 'A'" [checked]="preRadioSelect('A')">
                <span class="cuisine-name" style="display: block;">a. Currently we cannot provide an allergen free
                  preparation in our
                  kitchen.</span>
              </div>
              <div style="margin-bottom: 15px;">
                <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input" (change)="queAns = 'B'"
                  [checked]="preRadioSelect('B')">
                <span class="cuisine-name" style="display: block;">b. We strive hard to cater to some food allergies
                  or
                  intolerances if our
                  customers
                  communicate specific allergies or intolerances to us before placing the order
                  but cannot guarntee allergen free dishes.</span>
              </div>
              <div style="margin-bottom: 15px;">
                <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input" (change)="queAns = 'C'"
                  [checked]="preRadioSelect('C')">
                <span class="cuisine-name" style="display: block;">c. We cater to some food allergies and are
                  committed
                  avoid cross contamination
                  in our kitchen.</span>
              </div>
              <div style="margin-bottom: 15px;">
                <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input" (change)="queAns = 'D'"
                  [checked]="preRadioSelect('D')">
                <span class="cuisine-name" style="display: block;">d. Other </span>
                <textarea placeholder="Please give appropriate food allergy message" *ngIf="queAns == 'D'"
                  class="form-control" style="margin-top: 25px;" [(ngModel)]="queAnsOtherText"></textarea>
              </div>
            </div>
          </div>
          <div class="details-mainCon" id="deliveyPartner">
            <label for="">8. Please select an appropriate delivery partners (if any)</label>
            <div style="margin-left: 15px;">
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="delevryHandelFunc('deliveroo', $event.target)" [(checked)]="delverooCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/delivero-icon.png"
                      alt="" srcset="" style="max-width: 65px;"> Deliveroo </div>
                </div>
                <div class="offer-sub-div" *ngIf="delverooCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="delverooVal" placeholder="Please enter the url">
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="delevryHandelFunc('justEat', $event.target)" [(checked)]="justEatCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/just-eat-icon.png"
                      alt="" srcset="" style="max-width: 55px;"> JustEat </div>
                </div>
                <div class="offer-sub-div" *ngIf="justEatCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="justEatVal" placeholder="Please enter the url">
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="delevryHandelFunc('uberEats', $event.target)" [(checked)]="uberEatsCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/uber-eats-icon.png"
                      alt="" srcset=""> Uber Eats </div>
                </div>
                <div class="offer-sub-div" *ngIf="uberEatsCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="uberEatsVal" placeholder="Please enter the url">
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="delevryHandelFunc('foodstuff', $event.target)" [(checked)]="foodstuffCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img
                      src="../../../assets/img/foodstuff-removebg-preview.png" alt="" srcset=""
                      style="max-width: 45px;">
                    Foodstuff </div>
                </div>
                <div class="offer-sub-div" *ngIf="foodstuffCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="foodstuffVal" placeholder="Please enter the url">
                </div>

              </div>
            </div>
            <!-- <div class="deselect-btn">
            <div (click)="deselectOffer()" style="cursor: pointer;">Deselect all</div>
          </div> -->
          </div>
          <div class="details-mainCon" id="socialLink">
            <label for="">9. Select the social media platforms you are active on and provide their URLs </label>
            <div style="margin-left: 15px;">
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="socialLinkHandelFunc('insta', $event.target)" [(checked)]="instagramCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img
                      src="../../../assets/img/Instagram-Logo.wine.svg" alt="" srcset="" style="max-width: 65px;">
                    Instagram </div>
                </div>
                <div class="offer-sub-div" *ngIf="instagramCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="instagramVal" placeholder="Please enter the url">
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="socialLinkHandelFunc('facebook', $event.target)" [(checked)]="facebookCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img
                      src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset=""
                      style="max-width: 65px;">
                    Facebook </div>
                </div>
                <div class="offer-sub-div" *ngIf="facebookCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="facebookVal" placeholder="Please enter the url">
                </div>
              </div>
              <div class="offer-main-div">
                <div class="offer-sub-div">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    (change)="socialLinkHandelFunc('google-map', $event.target)" [(checked)]="googleMapCon">
                  <div class="cuisine-name" style="margin-top: 0;"> <img
                      src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset=""
                      style="max-width: 65px;">
                    Google Map </div>
                </div>
                <div class="offer-sub-div" *ngIf="googleMapCon">
                  <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                    [(ngModel)]="googleMapVal" placeholder="Please enter the url">
                </div>
              </div>
            </div>
            <!-- <div class="deselect-btn">
            <div (click)="deselectOffer()" style="cursor: pointer;">Deselect all</div>
          </div> -->
          </div>
          <div class="details-mainCon">
            <div>
              <label for="">10. Please add any other description or tags that are associated and relevant to your Food
                business separated by commas.</label>
              <textarea name="otherDescriptionOrTags" id="" cols="30" rows="10"
                placeholder="Example: Pool table, Board games, Proper pub, Nice Wine collection, Wine and Cheese, etc"
                class="form-control" style="height:100px" [(ngModel)]="otherDescriptionOrTags"></textarea>

            </div>
          </div>
          <div class="details-mainCon">
            <div>
              <label for="">11. Finally, select the Food allergies that you cater to<br>
                (Please select this carefully as this will help relevant customers find you)</label>
              <div class="cuisine-div" id="allergien">
                <div *ngFor="let item of allAllergens" style="display: flex; margin-bottom :15px;">
                  <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                    [checked]="preSelectFunc('allergies',item.id)"
                    (change)="allergensCheckedUncheckedFunc($event.target, item.id)">
                  <div class="cuisine-name"> {{item.name}}</div>
                </div>
              </div>

            </div>
            <div class="deselect-btn">
              <div (click)="deselect('allergien')" style="cursor: pointer;">Deselect all</div>
            </div>
          </div>


        </div>
      </div>
      <div style="padding-bottom: 10rem;" *ngIf="restoDetailsCondition">
        <button class="next-menu-btn" (click)="nextPageFunc()">
          Next
        </button>
      </div>
      <div style="padding-bottom: 10rem;" *ngIf="!restoDetailsCondition">
        <button class="next-menu-btn" (click)="submitClaimFunc()">
          Submit
        </button>
      </div>
    </div>
    <div class="lastDiv" *ngIf="last">
      <div>
        <div style="text-align: center;"> Thanks for claiming your business!</div>
        <div style="text-align: center;">Your response has been successfully submited</div>
      </div>
    </div>
  </div>
</div>
<!-- ----------------------------------------------------------------------------------------------------------------- -->
<style>
  ::ng-deep body {
    overflow: scroll !important;
  }

  .heading-top {
    text-align: center;
    margin-top: 20px;
  }

  .profile-section {
    display: flex;
    padding-bottom: 17px;
    margin-top: 19px;
    margin-bottom: 15px;
    border-bottom: 2px solid #E6E6E6;
  }

  .profile-section img {
    margin-left: 11px;
    border-radius: 50%;
  }

  .profile-section div {
    margin: auto;
  }

  .profile-section div h3 {
    margin: 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 12px;
  }

  .profile-section div span {
    color: #A1A7AB;
    font-size: 12px;
    width: 100%;
    display: block;
    text-align: center;
  }

  .heading-subDel {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #A1A7AB;
    margin-bottom: 30px;
    display: inline-block;

  }

  label {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #175375;
    margin-bottom: 5px;
    text-align: justify;
  }

  .sub-mainDiv {
    margin-left: 15px;
    display: flex;
    margin-right: 20px;
  }

  .side-div {
    min-width: 246px;
    height: 300px;
    background: #F8F8F8;
    box-shadow: 2px 2px 12px rgb(133 133 133 / 25%);
    border-radius: 12px;
    margin-right: 20px;
    position: sticky;
    left: 10px;
    top: 20px;
  }

  .side-subheading {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .side-details {
    width: 85%;
    padding: 10px;
    margin: auto;
    cursor: pointer;

  }

  .side-details img {
    width: 18px;
    margin-right: 10px;
  }

  .selected-bg {
    background-color: #D9EED5;
    border-radius: 6px;
  }

  .text-head {
    font-weight: 400;
    font-size: 24px;
    line-height: 40px;
  }

  .details-mainCon {
    border: 2px solid rgba(235, 235, 235, 0.79);
    border-radius: 12px;
    padding: 20px;
    border-right: 10px solid #4EA2D1;
    margin-bottom: 23px;
  }

  .uploadBtn {
    width: 121px;
    height: 41px;
    border-radius: 6px;
    background-color: rgba(84, 172, 88, 1);
    border: none;
    margin-left: 10px;
  }

  .uploadBtn span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: rgba(242, 242, 242, 1);
    padding-left: 10px;
  }

  .imgPreview {
    width: 51px;
    height: 51px;
    border-radius: 25px;
  }

  .imgPreview img {
    max-width: 66px;
  }

  .first-form-div {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }

  .second-form-div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .addBtn-mainDiv {
    width: 124px;
    height: 41px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1.5px solid #B6B6B6;
    border-radius: 4px;
    cursor: pointer;
  }

  .addBtn-mainDiv img {
    margin-right: 10px;
  }

  .addBtn-mainDiv span {
    font-weight: 400;
    font-size: 15px;
    line-height: 21px;
    color: #509941;
  }

  .next-menu-btn {
    width: 224px;
    height: 46px;
    background: linear-gradient(91.85deg, #56AB51 39.98%, #2FB9E3 227.02%);
    box-shadow: 0px 2px 4px rgb(0 0 0 / 25%);
    border-radius: 6px;
    border: none;
    float: right;
    margin-right: 20px;
    font-weight: 700;
    font-size: 18px;
    color: #FFFFFF;
  }

  .next-menu-btn:hover {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }

  .menu-first-div {
    display: flex;
  }

  .menu-first-div div:nth-child(2) {
    margin: auto 20px;
    color: #737373;
  }

  .cuisine-div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    margin-left: 40px;
    margin-top: 12px;
  }

  input.largerCheckbox {
    width: 27px;
    height: 27px;
  }

  .cuisine-name {
    margin-top: 8px;
    margin-left: 26px;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .time-input {
    border: none;
    border-bottom: 1px solid #2E8198;
    width: 35px;
    text-align: center;
    background: transparent;
  }

  .time-input:focus {
    outline: none;
    /* border: none; */
  }

  .time-selectOption {
    border: none;
    background: none;
    width: 50px;
  }

  .time-selectOption:focus {
    outline: none;
  }

  .time-text {
    color: #2E8198;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    text-decoration: underline;
    margin-bottom: 10px;
    display: block;
  }

  input.form-radio {
    width: 20px;
    height: 20px;
  }

  .deselect-btn {
    display: flex;
    justify-content: end;
    cursor: pointer;
    font-size: 16px;
    line-height: 23px;
    color: #737373;
  }

  .clear-timeBtn {
    margin-left: 10px;
    color: #737373;
    cursor: pointer;
  }

  .offer-main-div {
    display: grid;
    grid-template-columns: 1fr 2fr;
  }

  .offer-sub-div {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    margin-right: 27px;
  }

  .offer-div {
    margin: auto 14px auto 0px;
  }

  .form-check-input:checked {
    background-color: #509941;
    border-color: #509941;
  }

  .form-check-input:focus {
    border-color: #509941;
    box-shadow: none;
  }

  .feature-img-priview {
    padding: 20px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #B6B6B6;
    background: #F6F6F6;
  }

  .menu-img-preview-main {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .pdfMainSpan {
    display: flex;
    max-height: 30px;
    overflow: hidden;
    line-height: 15px;
    cursor: context-menu;
    margin-bottom: 10px;
  }

  .pdfMainSpan img {
    height: 30px;
  }

  .smallScreen {
    display: none;
  }

  .smallTimeSubDiv {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .clear-copyDiv {
    display: inline-flex;
    align-items: center;
  }

  .clear-copyDiv div {
    font-size: 30px;
    margin: 0px 10px;
    color: gray;
  }

  .clear-copyDiv button {
    background: linear-gradient(91.85deg, #56AB51 39.98%, #2FB9E3 227.02%);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    color: #FFFFFF;
    font-size: 14px;
  }

  .lastDiv {
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    line-height: 44px;
    color: chocolate;
  }

  .open-close-select-bigScreen {
    max-width: 43%;
  }

  .open-close-select-smallScreen {
    margin-left: 30%;
  }


  .inputBoxErrorClass {
    box-shadow: none;
    border: 1px solid #f47373;
  }

  .divConitainerErrorClass {
    border: 2px solid rgb(255 9 9);
    border-right: 10px solid rgb(255 9 9);
  }

  .special-offer-label {
    color: black !important;
    margin-bottom: 5px !important;
    font-size: 14px !important;
  }

  .m-l-0 {
    margin-left: 0px !important;

  }

  .m-t-10 {
    margin-top: 10px;
  }

  .p-l-20 {
    padding-left: 20px;
  }

  .m-t-20 {
    margin-top: 20px;
  }

  .mobile-side-deatils {
    width: 100%;
  }

  .mobile-side-div {
    display: none;
  }

  .copyDiv-2 {
    display: none;
  }

  .copyImg-1 {
    display: inline-block;
  }

  .copyImg-2 {
    display: none !important;
  }





  .cl_con_3 {
    padding: 0 3rem;
  }

  .social_link_main_div {
    margin-left: 40px;
    margin-top: 12px;
  }


  .cotum_loader {
    position: fixed;
    top: 0;
    height: 100vh;
    width: 100vw;
    background: #237C96;
    z-index: 11;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }


  .step1_loader {
    background: #FFFFFF;
    border-radius: 12px;
    padding: 28px;


  }









  @media screen and (max-width: 532px) {
    .cl_con_3 {
      padding: 0 10px !important;
    }

    .cl_card_body {
      padding: 1rem 2px !important;
    }

    .cl_grid {
      grid-template-columns: 1fr !important;
      gap: 0rem !important;
    }

    .time-text {
      font-size: 14px !important;
    }

    .cuisine-div {
      margin-left: 19px !important;

    }

    .cuisine-name {
      font-size: 12px !important;
      margin-left: 0px !important;

      img {
        max-width: 46px !important;
      }
    }

    .time-input {
      font-size: 12px !important;
      width: 26px !important;
    }

    .time-selectOption {
      width: 39px !important;
      font-size: 12px !important;
    }

    .social_link_main_div {
      margin-left: 19px !important;
    }

    .offer-main-div {
      grid-template-columns: 1fr !important;
    }

    .container_img_slider_div {
      height: 200px !important;
    }
  }



  .preloading_main_div {
    position: fixed;
    top: 0;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    background: #000000b3;
    display: flex;
    justify-content: center;
    align-items: center;

    .loader {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: 32px 0 #fff, -32px 0 #fff;
      position: relative;
      animation: flash 0.5s ease-out infinite alternate;
    }

    @keyframes flash {
      0% {
        background-color: #FFF2;
        box-shadow: 32px 0 #FFF2, -32px 0 #FFF;
      }

      50% {
        background-color: #FFF;
        box-shadow: 32px 0 #FFF2, -32px 0 #FFF2;
      }

      100% {
        background-color: #FFF2;
        box-shadow: 32px 0 #FFF, -32px 0 #FFF2;
      }
    }

  }


  .banner-rail {
    position: relative;
    margin-bottom: 12px;
    place-items: center;
  }

  .banner {
    display: flex;
    justify-content: space-between;
    background: #ecfdf5;
    border: 1px solid #34d399;
    color: #065f46;
    padding: 12px 16px;
    border-radius: 14px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  }

  .banner-sub {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .icon {
    width: 22px;
    height: 22px;
    flex: 0 0 auto;
  }

  .msg {
    margin: 0;
  }

  .msg strong {
    font-weight: 700;
  }

  .spacer {
    inline-size: 1px;
    flex: 1 1 auto;
  }

  .action {
    border: 1px dashed #34d399;
    padding: 6px 10px;
    border-radius: 10px;
    text-decoration: none;
    font-weight: 600;
    white-space: nowrap;
  }

  .close {
    cursor: pointer;
    display: grid;
    place-items: center;
    width: 34px;
    height: 34px;
    border-radius: 999px;
    border: none;
    background: transparent;
  }

  .close:hover {
    background: rgba(0, 0, 0, 0.04);
  }


  .msg {
    overflow-wrap: anywhere;
    /* wrap long emails/words */
    line-height: 1.35;
  }

  /* Keep banner tidy even with long content */
  .banner {
    display: grid;
    /* left content + close button */
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px;
  }

  /* Mobile adjustments */
  @media (max-width: 520px) {
    .banner {
      padding: 10px 12px;
      border-radius: 12px;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
    }

    /* Icon + text on two neat columns, allow text to fill */


    .icon {
      width: 20px;
      height: 20px;
      margin-top: 2px;
      /* optical align with text */
    }

    .spacer {
      display: none;
      /* remove flex spacer on mobile */
    }

    .close {
      width: 32px;
      height: 32px;
      margin-right: -4px;
      /* pulls it a touch to the edge */
    }
  }

  /* Optional: tighter smallest screens */
  @media (max-width: 360px) {
    .msg strong {
      display: block;
      margin-bottom: 2px;
    }
  }
</style>